<div class="flex justify-content-center">
	<div class="flex flex-column" [ngClass]="getBorderColor()">
		<div class="flex flex-row align-items-center justify-content-around gap-6 pt-2 px-3">
			<!-- MODALITY: FIRST FIELD -->
			<div *ngIf="thermo.current_season ==='winter'" class="flex align-items-center">
				<i class="pi cm-snow text-2xl text-primary pr-2"></i>
				{{ 'MODALITY' | translate }}: {{ 'TH_WINTER' | translate }}
			</div>
			<div *ngIf="thermo.current_season ==='summer'" class="flex align-items-center">
				<i class="pi cm-sun text-2xl text-red-600 pr-2"></i>
				{{ 'MODALITY' | translate }}: {{ 'TH_SUMMER' | translate }}
			</div>
			<div *ngIf="thermo.current_season ==='antifreeze'" class="flex align-items-center">
				<i class="pi cm-antifreeze text-2xl text-primary pr-2"></i>
				{{ 'MODALITY' | translate }}: {{ 'TH_ANTIFREEZE' | translate }}
			</div>
			<!-- RELAY: CENTRAL / SECOND FIELD -->
			<div *ngIf="thermo.relay_status === 1" class="flex align-items-center">
				<i class="pi cm-termo text-2xl pr-2"
					[class]="thermo.current_season ==='summer' ? 'text-primary' : 'text-red-600'">
					<!-- summer -> color blue because is A/C fresh, winter -> color red because is warm air -->
				</i>
				<div [class]="thermo.current_season ==='summer' ? 'text-primary' : 'text-red-600'">{{ 'RELAY_ON' |
					translate }}</div>
			</div>
			<div *ngIf="thermo.relay_status === 0" class="flex align-items-center">
				<i class="pi cm-termo text-2xl text-0 pr-2"></i>
				{{ 'TH_OFF' | translate }}
			</div>
			<!-- HUMIDITY: THIRD FIELD -->
			<div class="flex align-items-center">
				<i class="pi pi-cloud text-2xl text-primary pr-2"></i>
				{{ "HUMIDITY" | translate }}:
				{{ thermo.hum_loc === undefined ? '- %' : thermo.hum_loc + ' %' }}
			</div>
		</div>
		<div class="flex flex-column py-4 w-full">
			<div class="temp-att-val flex justify-content-center" [class]="!onExtendedMobile() ? 'text-7xl' : 'text-6xl'">
				{{ thermo.temp_loc + ' °C' }}
			</div>
			<div class="temp-att-txt flex justify-content-center">
				{{ 'CURRENT_TEMPERATURE' | translate }}
			</div>
		</div>
	</div>
</div>
